import Layout from "src/components/layout/Layout";
import NotificationSettings from "src/components/settings/notifications/NotificationSettings";
import useAuth from "src/hooks/selectors/useAuth";

export default function SettingsView() {
	const auth = useAuth();

	return (
		<Layout title="Instellingen">
			{auth.type === "student" && (
				<Layout.Header title="Instellingen" backUrl="/dashboard" />
			)}
			<NotificationSettings />
		</Layout>
	);
}
